import Beacons from 'modules/beacons/utils';
import { QuartileKey } from 'tag/models/common/common';

export const firstQuartileListener = (adserverRequestId: string) => {
  Beacons.fire.videoQuartile(QuartileKey.Q25, adserverRequestId, true);
};
